import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { InsertSeries } from "../lib/supabase";
import SeriesForm from "../components/series/SeriesForm";
import SmartBackButton from "../components/ui/SmartBackButton";
import toast from "react-hot-toast";
import { ENTITY_NAMES } from "../constants/entities";

interface Lab {
  title: string;
  description: string;
  order_number: number;
  learning_outcomes: string[];
  resources: string[];
  series_id?: string;
}

const AddSeries: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleAddSeries = async (formData: InsertSeries & { labs?: Lab[] }) => {
    try {
      setIsLoading(true);

      // Remove any id field if it exists
      const { id: _, labs, ...seriesData } = formData;

      // Create the series first
      const { data: newSeries, error: seriesError } = await supabase
        .from("series")
        .insert([seriesData])
        .select()
        .single();

      if (seriesError) throw seriesError;

      // Create labs if provided
      if (labs && labs.length > 0) {
        const labsWithSeriesId = labs.map((lab: Lab) => ({
          ...lab,
          series_id: newSeries.id,
        }));

        const { error: labsError } = await supabase
          .from("labs")
          .insert(labsWithSeriesId);

        if (labsError) {
          console.error("Error creating labs:", labsError);
          toast.error("Series created but failed to create labs");
        } else {
          toast.success("Series and labs added successfully");
        }
      } else {
        toast.success("Series added successfully");
      }

      navigate(`/series/${newSeries.id}`);
    } catch (error) {
      console.error("Error adding series:", error);
      toast.error("Failed to add series");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="flex items-center mb-6">
        <SmartBackButton
          fallbackPath="/series"
          className="text-link hover:text-hover flex items-center"
        />
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-neutral-200 overflow-hidden">
        <div className="p-6">
          <div className="flex justify-between items-start mb-6">
            <h1 className="">Add New {ENTITY_NAMES.SERIES}</h1>
          </div>

          {/* Workflow guidance */}
          <div className="">
            {/* <h2 className="mb-2">Next Steps After Creating Your Series</h2> */}
            <p className="mb-6">
              After creating this series, groups and labs can be added from the
              Series Detail page or directly from the Groups and Labs sections.
            </p>
          </div>

          <SeriesForm onSubmit={handleAddSeries} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default AddSeries;
